import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"
import Shoot from "./shoot"
import { postLogDetails } from "../../../Services/APIs/appDetails";


const FullScan = () => {
    const { uid, company } = useSelector(state => state.smileWhite);

    console.log("UID from Redux:", uid);
    useEffect(() => {
        if (!uid) {
            navigate("/")
        } else {
            postLogDetails({ app: "smile-white", payLoad: "On demo screen", uid: uid })
        }
    }, [uid, company])

    const [isToothPicker, setToothPicker] = useState(true)
    const [activeImageSide, setImageSide] = useState(0)
    const navigate = useNavigate()


    return (
        <div className="h-full">
            {
                // isToothPicker ?
                // <ToothSelector setImageSide={setImageSide} setToothPicker={setToothPicker} /> :
                <Shoot activeImageSide={activeImageSide} setToothPicker={setToothPicker} quickScan={false} setImageSide={setImageSide} />
            }
        </div>
    )
}

export default FullScan